import gql from 'graphql-tag';

const COOKIES_PAGE_QUERY = gql`
    query {
        cookiesPage {
            content {
                title
                subtitle
                text
                image {
                    url
                }
            }
        }
    }
`;

export default COOKIES_PAGE_QUERY;
